export default __webpack_public_path__ + "static/media/5.cc4d59d5.png";